export default __webpack_public_path__ + "static/media/nobel.5ad3c5fc.svg";